import React from 'react';
import { Fab, Stack } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EventIcon from '@mui/icons-material/Event';
import { useNavigate } from 'react-router-dom';

export default function StickyCTAs() {
  const navigate = useNavigate();
  return (
    <Stack spacing={1} sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1200 }}>
      <Fab color="primary" aria-label="Call Now" href="tel:+18125550168">
        <PhoneIcon />
      </Fab>
      <Fab color="primary" aria-label="Book Appointment" onClick={() => navigate('/book')}>
        <EventIcon />
      </Fab>
    </Stack>
  );
}
